import React, { useEffect } from "react"
import { Navigate } from "react-router-dom"
import { ProductOption } from "app/components/ProductOption"
import { useAppflow } from "app/hooks/useAppFlow"
import Button from "app/components/Button"
import { ReactComponent as ArrowLeft } from "app/assets/svg/arrow-left.svg"
import LanguageSwitch from "app/components/LanguageSwitch"
import { useDispatch } from "react-redux"
import { setLocale } from "state/app/slice"
import Heading from "app/components/Heading"
import { locales, Locales } from "i18n"
import { useTranslate } from "hooks/translate"
import { getAvailableProducts } from "./Products/products"
import { ClientEnum, CarEnum } from "./types"
import { ClientTypeSelector } from "./ClientTypeSelector"
import { CarTypeSelector } from "./CarTypeSelector"
import { StyledGrid } from "./style"
import { AppProduct } from "./AppProduct/index"

export const AppFlowPage: React.FC = () => {
  const dispatch = useDispatch()
  const { t } = useTranslate()
  const { clientType, carType, product, navigate, goBack, step, lang } =
    useAppflow()

  useEffect(() => {
    if (!lang) return

    const locale = lang as Locales

    if (locales.includes(locale)) {
      dispatch(setLocale(locale))
    }
  }, [lang, locales])

  if (
    clientType &&
    ![ClientEnum.Business, ClientEnum.Private].includes(clientType)
  ) {
    return <Navigate to="/error" />
  }
  if (carType && ![CarEnum.New, CarEnum.Used].includes(carType)) {
    return <Navigate to="/error" />
  }

  const availableProducts = getAvailableProducts(clientType!, carType!)

  const selectedProduct = availableProducts.find(p => p.key === product)

  if (product && !availableProducts.some(c => c.key === product)) {
    return <Navigate to="/error" />
  }

  if (selectedProduct && step) {
    return <AppProduct component={selectedProduct.component} />
  }

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <p>{t("system.choose_product.title")}</p>
        <LanguageSwitch />
      </div>
      <div
        style={{
          height: "100%",
          display: "flex",
          flexDirection: "column",
          justifyContent: "space-between"
        }}
      >
        {!clientType && <ClientTypeSelector />}
        {!carType && <CarTypeSelector />}
        {availableProducts.length > 0 && (
          <div>
            <Heading>{t("system.choose_product.description")}</Heading>
            <StyledGrid>
              {availableProducts.map((p, i) => (
                <ProductOption
                  key={i}
                  title={t(`system.product.${p.key}.title`)}
                  description={t(`system.product.${p.key}.description`)}
                  cta={t("system.start_request")}
                  onClick={() => navigate(clientType, carType, p.key, 1)}
                />
              ))}
            </StyledGrid>
          </div>
        )}
        {!!clientType && (
          <Button
            icon={ArrowLeft}
            iconPlacement="prefix"
            variant="plain"
            onClick={goBack}
          >
            {t("system.back")}
          </Button>
        )}
      </div>
    </div>
  )
}
